package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.ir.eval.ValueCoercion
import kotlin.jvm.JvmStatic

/**
 * 运行时变换属性贡献者：translateX / translateY / scaleX / scaleY / opacity 等通用元素属性。
 */
@Suppress("CyclomaticComplexMethod", "LongMethod")
internal object TransformPropContributor {

    @JvmStatic
    fun contribute(m: MutableMap<String, PropBinding>) {
        m.put(
            "translateX",
            PropBinding.of(
                { el, v -> el.translateX(ValueCoercion.toFloat(v)) },
                { el -> el.translateX().toDouble() },
            ),
        )
        m.put(
            "translateY",
            PropBinding.of(
                { el, v -> el.translateY(ValueCoercion.toFloat(v)) },
                { el -> el.translateY().toDouble() },
            ),
        )
        m.put(
            "scaleX",
            PropBinding.of(
                { el, v -> el.scaleX(ValueCoercion.toFloat(v)) },
                { el -> el.scaleX().toDouble() },
            ),
        )
        m.put(
            "scaleY",
            PropBinding.of(
                { el, v -> el.scaleY(ValueCoercion.toFloat(v)) },
                { el -> el.scaleY().toDouble() },
            ),
        )
        m.put(
            "opacity",
            PropBinding.of(
                { el, v -> el.opacity(ValueCoercion.toFloat(v)) },
                { el -> el.opacity().toDouble() },
            ),
        )
        m.put(
            "rotation",
            PropBinding.of(
                { el, v -> el.rotation(ValueCoercion.toFloat(v)) },
                { el -> el.rotation().toDouble() },
            ),
        )
        m.put(
            "rotateX",
            PropBinding.of(
                { el, v -> el.rotateX(ValueCoercion.toFloat(v)) },
                { el -> el.rotateX().toDouble() },
            ),
        )
        m.put(
            "rotateY",
            PropBinding.of(
                { el, v -> el.rotateY(ValueCoercion.toFloat(v)) },
                { el -> el.rotateY().toDouble() },
            ),
        )
        m.put(
            "skewX",
            PropBinding.of(
                { el, v -> el.skewX(ValueCoercion.toFloat(v)) },
                { el -> el.skewX().toDouble() },
            ),
        )
        m.put(
            "skewY",
            PropBinding.of(
                { el, v -> el.skewY(ValueCoercion.toFloat(v)) },
                { el -> el.skewY().toDouble() },
            ),
        )
        m.put(
            "perspective",
            PropBinding.of(
                { el, v -> el.perspective(ValueCoercion.toFloat(v)) },
                { el -> el.perspective().toDouble() },
            ),
        )
        m.put(
            "transformOrigin",
            PropBinding.writeOnly { el, v ->
                val origin = ValueCoercion.toOrigin(v)
                el.originX(origin[0]).originY(origin[1])
            },
        )
        m.put(
            "pointerEvents",
            PropBinding.of(
                { el, v -> el.pointerEvents(ValueCoercion.toBool(v)) },
                { el -> el.pointerEvents() },
            ),
        )
        m.put(
            "dropTarget",
            PropBinding.of(
                { el, v -> el.dropTarget(ValueCoercion.toBool(v)) },
                { el -> el.dropTarget() },
            ),
        )
        m.put(
            "visible",
            PropBinding.of(
                { el, v -> el.visible(ValueCoercion.toBool(v)) },
                { el -> el.visible() },
            ),
        )
        m.put(
            "aboveItem",
            PropBinding.of(
                { el, v -> el.aboveItem(ValueCoercion.toBool(v)) },
                { el -> el.aboveItem() },
            ),
        )
        m.put(
            "zIndex",
            PropBinding.of(
                { el, v -> el.zIndex(v?.let { ValueCoercion.toFloat(it).toInt() } ?: 0) },
                { el -> el.zIndex().toDouble() },
            ),
        )
        m.put(
            "overflow",
            PropBinding.of(
                { el, v -> el.overflow(UIElement.Overflow.parse(v?.toString())) },
                { el -> if (el.overflow() == UIElement.Overflow.HIDDEN) "hidden" else "visible" },
            ),
        )
    }
}
